<template>
  <div class="head-page" style="padding-bottom: 50px;">
    <HomeHeader @child-event="toMember" />
    <HomeSwipeImg />
    <HomeSwipeItem :datalst="dataLst" />
    <HomeMenus />
    <HomeRanking :datalst="dataLst" />
    <Footer />
    <van-popup v-model="show" position="left">
      <MemberInfo ref="memberinfo" @close-left="show=false" />
    </van-popup>
    <BulletinView :show="showPopup" @close-popup="ClosePopup" @open-popup="OpenPopup" />
  </div>
</template>

<script>
import Footer from "@/components/Footer/index.vue";
import {
  HomeHeader,
  HomeSwipeImg,
  HomeSwipeItem,
  HomeMenus,
  HomeRanking,
  MemberInfo,
  BulletinView
} from "./components/index";
import { getToken } from "@/utils/cookies";
export default {
  name: "HomeView",
  components: {
    Footer,
    HomeHeader,
    HomeSwipeImg,
    HomeSwipeItem,
    HomeMenus,
    HomeRanking,
    MemberInfo,
    BulletinView
  },
  data() {
    return {
      show: false,
      timer: null,
      dataLst: [],
      showPopup:false
    };
  },
  created() {
    if (sessionStorage.getItem("cachedData")) {
      this.show = JSON.parse(sessionStorage.getItem("cachedData"));
    }
  },
  watch: {
    show: {
      handler(newVal) {
        sessionStorage.setItem("cachedData", JSON.stringify(newVal));
        if(newVal && this.$refs.memberinfo)
        this.$refs.memberinfo.getMemberInf();
      },
      deep: true, // 深度监听对象/数组变化
    },
  },
  mounted() {
    if(!getToken()){
      this.show = false
    }
    this.getData();
    const that = this;
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getData();
      }, 10000);
    });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    ClosePopup(){
      this.showPopup = false
    },
    OpenPopup(){
      this.showPopup = true
    },
    toMember() {
      const token = getToken();
      if (token && token.length > 0) {
        this.show = true;
        const that = this;
        this.$nextTick(() => {
          that.$refs.memberinfo.getMemberInf();
        });
      } else {
        this.$router.push(
          {
            name: "login",
          },
          () => {}
        );
      }
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getMarketList",
      }).then((res) => {
        if (res && res.data && res.data.list) this.dataLst = res.data.list;
      });
    },
  },
};
</script>

<style>
</style>



